import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { BulkJobStep, useCurrentModalContext } from '../../providers/ModalProvider';

export const ErrorStep = () => {
  const { onSuccess, step, error } = useCurrentModalContext();

  if (step !== BulkJobStep.JobsSubmittedWithErrors) {
    return null;
  }

  return (
    <div className="step-wrapper">
      <div className="text-red-500">Jobs submitted with errors, please check job list</div>

      {error ? <div className="errorMessage">{error}</div> : null}

      <div className="buttonContainer">
        <OutlinedButton onClick={onSuccess}>Cancel</OutlinedButton>
        <Button className="ml-4" onClick={onSuccess}>
          Close
        </Button>
      </div>
    </div>
  );
};
